import React from 'react';
import { ShowButton, FunctionField, Datagrid, DateField, TextField } from 'react-admin';
import TList from '../../components/wrapper/TList';
import { gatewayRenderer } from './PaymentTransactionLogConstants';

const PaymentTransactionLogList = props => (
	<TList exporter={false} {...props} sort={{ field: 'creationDateTime', order: 'DESC' }}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<DateField source="creationDateTime" />
			<DateField source="completionDateTime" />
			<TextField source="requestId" sortable={false} />
			<TextField source="status" sortable={false} />
			<TextField source="authorizationId" sortable={false} />
			<FunctionField source="gatewayIdentifier" render={gatewayRenderer} sortable={false} />
		</Datagrid>
	</TList>
);

export default PaymentTransactionLogList;
